import RadioGroup, { RadioGroupProps } from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

export type EmtRadioGroupProps = RadioGroupProps & {
  /**
   * Display title of button group
   * @default undefined
   */
  title?: string;
  nonce?: string;
};

export function EmtRadioGroup(props: EmtRadioGroupProps) {
  const { title, ...rest } = props;
  return (
    <FormControl>
      {title && <FormLabel sx={{ marginLeft: "-10px" }}>{title}</FormLabel>}
      <RadioGroup {...rest} />
    </FormControl>
  );
}
